export const DataRouteParamModuleId = 'moduleId';
